import { useStoreEmails } from '@/hooks/store/useStoreEmails';
import { useStore } from '@/hooks/store/useStore';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import { IoCallSharp, IoLocationSharp, IoMail } from 'react-icons/io5';

interface Props {
  image?: HTMLImageElement;
}
const ContactInfoBlock: FC<Props> = () => {
  const { t } = useTranslation('common');
  const store = useStore();
  const customerSupportEmail = useStoreEmails('customer_support_email').sender_email;
  const storeName = store?.store_information_config?.store_name
  const storeStreetAddressOne = store?.store_information_config?.store_street_address_one;
  const storeStreetAddressTwo = store?.store_information_config?.store_street_address_two;
  const storeCity = store?.store_information_config?.store_city;
  const storeAddressZipCode = store?.store_information_config?.store_zip_code;
  const storePhoneNumber = store?.store_information_config?.store_phone_number;

  const description =
    storeName + '<br/>' +
    storeStreetAddressOne + '<br/>' +
    (storeStreetAddressTwo ? storeStreetAddressTwo + '<br/>' : '') +
    storeAddressZipCode + ' ' + storeCity;

  const data = [
    {
      id: 1,
      icon: <IoLocationSharp />,
      name: 'text-address',
      description: description,
    },
    {
      id: 2,
      icon: <IoMail />,
      name: 'text-email',
      description: customerSupportEmail,
    },
    {
      id: 3,
      icon: <IoCallSharp />,
      name: 'text-phone',
      description: storePhoneNumber,
    },
  ];
  return (
    <div className="mb-6 border-gray-300 lg:border lg:p-7">
      <h4 className="-mt-1 pb-7 text-2xl font-bold text-heading md:pb-10 md:text-lg lg:pb-6">{t('text-contact')}</h4>
      {data?.map((item: any) => (
        <div
          key={`contact--key${item.id}`}
          className="flex pb-7 last:pb-0"
        >
          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center border border-gray-300 p-1.5">
            {item.icon}
          </div>
          <div className="flex flex-col ps-3 2xl:ps-4">
            <h5 className="text-sm font-bold text-heading">{t(`${item.name}`)}</h5>
            <div className="mt-0 text-sm">
              <div dangerouslySetInnerHTML={{ __html: item.description }}></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ContactInfoBlock;
